import { render, staticRenderFns } from "./order_assignment_methods.vue?vue&type=template&id=aaa5aa6e&scoped=true&"
import script from "./order_assignment_methods.vue?vue&type=script&lang=js&"
export * from "./order_assignment_methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa5aa6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaa5aa6e')) {
      api.createRecord('aaa5aa6e', component.options)
    } else {
      api.reload('aaa5aa6e', component.options)
    }
    module.hot.accept("./order_assignment_methods.vue?vue&type=template&id=aaa5aa6e&scoped=true&", function () {
      api.rerender('aaa5aa6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/order_assignment_methods.vue"
export default component.exports